import {User} from "../types";

export const getRolesFromUserData = (userData: User): string[] => {
    return userData?.roles || [];
};

export const getImpersonatorRolesFromUserData = (userData: User): string[] => {
    return userData?.impersonatorRoles || [];
};
